export default "__VITE_ASSET__BzbrZyTZ__"